export default "__VITE_ASSET__Ber$w2vy__"